import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-pdf-url-row',
    imports: [],
    templateUrl: './pdf-url-row.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './pdf-url-row.component.scss'
})
export class PdfUrlRowComponent {

}
